
import Vue from 'vue'

import { MetaInfo } from 'vue-meta'

import RecruitLinkList from '~/components/career/recruit-link-list.vue'
import AuroraBackground from '~/components/common/aurora-background.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import RecruitKv from '~/sections/recruit/kv.vue'

export default Vue.extend({
  name: 'RecruitPage',
  components: {
    TextPressure,
    AuroraBackground,
    RecruitKv,
    RecruitLinkList,
    PageBottom,
    FooterNew
  },
  mixins: [TextPressureMixin],
  layout: 'home',

  head(): MetaInfo {
    const title = 'RECRUIT | DeNA×AI'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
})
